import axios from 'axios'
import { AUTH_HEADERS } from '../utils/config'

export default {
    get () {
        return axios.get(`${process.env.VUE_APP_BASE_URL}User`, AUTH_HEADERS())
    },
    getById (id) {
        return axios.get(`${process.env.VUE_APP_BASE_URL}User/${id}`,  AUTH_HEADERS())
    },
    getArchived () {
        return axios.get(`${process.env.VUE_APP_BASE_URL}User/archived`, AUTH_HEADERS())
    },
    update (user) {
        return axios.put(`${process.env.VUE_APP_BASE_URL}User/${user.id}`, user,  AUTH_HEADERS())
    },
    delete (id) {
        return axios.put(`${process.env.VUE_APP_BASE_URL}User/delete/${id}`, id, AUTH_HEADERS())
    },
    archive (id) {
        return axios.put(`${process.env.VUE_APP_BASE_URL}User/archive/${id}`, id,  AUTH_HEADERS())
    },
    restore (id) {
        return axios.put(`${process.env.VUE_APP_BASE_URL}User/restore/${id}`, id,  AUTH_HEADERS())
    },
    create (credentials) {
        return axios.post(`${process.env.VUE_APP_BASE_URL}User`, credentials,  AUTH_HEADERS())
    }
}
